"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/VideoOverlay.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _previewSupport = require('shared/utils/previewSupport');
var _PlayGlyph = require('./PlayGlyph'); var _PlayGlyph2 = _interopRequireDefault(_PlayGlyph);





const VideoOverlay = ({ durationMs }) => {
  const duration = _previewSupport.formatMediaDuration.call(void 0, durationMs)

  return (
    _react2.default.createElement('div', { className: "file-message--video-overlay", 'data-testid': "video-overlay", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('span', { className: "file-message--video-overlay--play", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
        , _react2.default.createElement(_PlayGlyph2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 16}} )
      )
      , duration && (
        _react2.default.createElement('span', { className: "file-message--video-overlay--duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, duration)
      )
    )
  )
}

exports. default = VideoOverlay
